/**
 * Extrai o hash da URL atual
 * @param url - URL completa (opcional, usa window.location.href se não fornecida)
 * @returns Hash extraído da URL ou null se não encontrado
 */
export const extrairHashDaURL = (url?: string): string | null => {
  try {
    const urlAtual =
      url || (typeof window !== "undefined" ? window.location.href : "");
    const urlObj = new URL(urlAtual);
    const hash = urlObj.searchParams.get("hash");
    return hash;
  } catch (error) {
    console.error("Erro ao extrair hash da URL:", error);
    return null;
  }
};

export const extrairCodTransacaohDaURL = (url?: string): string | null => {
  try {
    const urlAtual =
      url || (typeof window !== "undefined" ? window.location.href : "");
    const urlObj = new URL(urlAtual);
    const cod = urlObj.searchParams.get("cdTrsOpr");
    return cod;
  } catch (error) {
    console.error("Erro ao extrair hash da URL:", error);
    return null;
  }
};

/**
 * Valida se o hash tem o formato correto
 * @param hash - Hash a ser validado
 * @returns boolean indicando se é válido
 */
export const validarHash = (hash: string): boolean => {
  if (!hash || typeof hash !== "string") {
    return false;
  }

  // Adicione aqui as validações específicas do seu hash
  // Por exemplo: comprimento mínimo, formato específico, etc.
  return hash.trim().length > 0;
};
